export var AffectedZone;
(function (AffectedZone) {
    AffectedZone["Whole"] = "whole";
    AffectedZone["Sparse"] = "sparse";
})(AffectedZone || (AffectedZone = {}));
